'use strict';
import {module} from '../app';

module.directive('numbersOnly', function () {
  return {
    require: 'ngModel',
    scope: {
      maxLength: "@",
      onlyInt: "@",
      allowNegative: "@"
    },
    link: function (scope, element, attr, ngModelCtrl) {
      function fromUser(text) {
        const textString = text && "" + text;
        if (textString && (scope.allowNegative && (textString.indexOf('-') === 0 && textString.length >=2 || textString.indexOf('-') === -1) || !scope.allowNegative)) {
          const pattern = scope.onlyInt && (!scope.allowNegative || textString.indexOf('-') === -1)
          ? /[0-9]+/g
          : scope.allowNegative
            ? /-+[0-9]+/g
          : /[0-9]+\.*[0-9]*/g
          return transformInput(textString, pattern);
        }
        return undefined;
      }

      function transformInput(text, pattern){
        var transformedInput = '';
          var validParts = text.match(pattern);
          if (validParts && validParts.length > 0) {
            transformedInput = validParts[0];
          }
          if (scope.maxLength) {
            transformedInput = transformedInput.substr(0, scope.maxLength)
          }

          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
      }

      ngModelCtrl.$parsers.push(fromUser);
    }
  };
});



// WEBPACK FOOTER //
// ./src/scripts/directives/numbersOnly.js